import { GlButtonGroup, GlCollapsibleListbox, GlLink } from '@gitlab/ui';
import ReviewAppLink from '../review_app_link.vue';
export default {
    name: 'DeploymentViewButton',
    components: {
        GlButtonGroup,
        GlCollapsibleListbox,
        GlLink,
        ReviewAppLink
    },
    props: {
        appButtonText: {
            type: Object,
            required: true
        },
        deployment: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            searchTerm: ''
        };
    },
    computed: {
        deploymentExternalUrl () {
            if (this.deployment.changes && this.deployment.changes.length === 1) {
                return this.deployment.changes[0].external_url;
            }
            return this.deployment.external_url;
        },
        shouldRenderDropdown () {
            return this.deployment.changes && this.deployment.changes.length > 1;
        },
        filteredChanges () {
            return this.deployment?.changes?.filter((change)=>change.path.includes(this.searchTerm)).map((change)=>({
                    value: change.external_url,
                    text: change.path
                }));
        }
    },
    methods: {
        search (searchTerm) {
            this.searchTerm = searchTerm;
        }
    }
};
